import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function CallsEdit() {
  let { id } = useParams();

  return (
    <>
      <edit-call id={id} />
    </>
  );
}

export default injectIntl(withAuth(CallsEdit));
